import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classes from './paymentTable.module.scss';

const header = [
  {
    name: 'Rx Number',
    path: 'rxNumber',
  },
  {
    name: 'Process ON',
    path: 'processedOn',
  },
  {
    name: 'Medication',
    path: 'Product.name',
  },
  {
    name: 'Amount',
    path: 'amount',
  },
  {
    name: 'Payment Option',
    path: 'paid',
  },
];

const PaymentTable = ({ payments, totalAmount }) => (
  <div className={classes.table_wrapper}>
    <table>
      <thead>
        <tr>
          {header.map((h) => (
            <th key={h.name}>{h.name}</th>
          ))}
        </tr>
      </thead>

      <tbody id="tbody">
        {payments?.map((d) => (
          <tr key={d.id}>
            {header.map((h) => (
              h.path === 'processedOn'
                ? (
                  <td key={h.name}>
                    {moment(d[h.path]).isValid()
                      ? moment(d[h.path]).format('MM/DD/YYYY')
                      : '-'}
                  </td>
                )

                : h.path === 'amount'
                  ? (
                    <td key={h.name}>
                      {_.get(d, h.path) ?? '-'}
                    </td>
                  )

                  : h.path === 'paid'
                    ? (
                      <td key={h.name}>
                        Paid with credit card
                      </td>
                    )
                    : <td key={h.name}>{_.get(d, h.path) ?? '-'}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>

    <div className={classes.total}>
      Total Pay:
      <span>
        {' '}
        $
        {totalAmount}
      </span>
    </div>
  </div>
);

PaymentTable.propTypes = {
  payments: PropTypes.array.isRequired,
  totalAmount: PropTypes.string.isRequired,
};

export default PaymentTable;
